
import { ref, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import { clone } from "ramda";
import { Skill, GetSkillResponse, UpsertSkillRequest } from "@/types";
import Fuse from "fuse.js";
import BackButton from "@/components/BackButton.vue";
export default {
  name: "Skill",
  components: { BackButton },
  setup() {
    const { success, error, axios, setLoading, padZero } = usePlugin();

    const skillTable = ref(null);
    const skills = ref<Skill[]>([]);
    const skill = ref<Skill>({} as Skill);
    const showDialog = ref(false);
    const popupDeleteDialog = ref(false);
    const searchString = ref("");
    const submitted = ref(false);
    const existSkillId = ref(false);
    const duplicateSkillId = ref(false);

    const filteredSkill = computed(() => {
      if (!searchString.value) return skills.value;
      const fuse = new Fuse(skills.value, {
        keys: ["skillId", "descriptionEN", "descriptionTH"],
      });
      const searchResult = fuse.search(searchString.value);
      return searchResult.map((x) => x.item);
    });

    const loadSkills = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetSkillResponse>(
          "api/v1/services/skill/get"
        );
        skills.value = result.data.skills ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onNewSkill = () => {
      skill.value = {} as Skill;
      showDialog.value = true;
      submitted.value = false;
      existSkillId.value = false;
    };

    const onSaveSkill = async () => {
      submitted.value = true;

      if (skill.value.id && skill.value.id.length > 0) {
        if (
          !existSkillId.value &&
          skills.value.find((comp) => comp.id === padZero(skill.value.id, 3))
        ) {
          //Create skill ID
          duplicateSkillId.value = true;
          return;
        }
        setLoading(true);
        try {
          const result = await axios.post("api/v1/services/skill/upsert", {
            skills: [
              {
                id: padZero(skill.value.id, 3),
                descriptionTH: skill.value.descriptionTH,
                descriptionEN: skill.value.descriptionEN,
              },
            ],
          } as UpsertSkillRequest);
          await loadSkills();
          success("บันทึกข้อมูลสำเร็จแล้ว");
          showDialog.value = false;
        } catch (e) {
          error(e);
        } finally {
          setLoading(false);
        }
      }
    };

    const onHideDialog = () => {
      showDialog.value = false;
      submitted.value = false;
      duplicateSkillId.value = false;
    };

    const onEditSkill = (source: Skill) => {
      skill.value = clone(source);
      showDialog.value = true;
      existSkillId.value = true;
    };

    const onDeleteSkill = (source: Skill) => {
      skill.value = clone(source);
      popupDeleteDialog.value = true;
    };

    const handleDeleteSkill = async () => {
      setLoading(true);
      try {
        const result = await axios.delete("api/v1/services/skill/delete", {
          data: {
            skills: [skill.value],
          } as UpsertSkillRequest,
        });
        await loadSkills();
        success("ลบข้อมูลสำเร็จแล้ว");
        popupDeleteDialog.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
      // }
    };

    onMounted(async () => {
      await loadSkills();
    });
    return {
      skillTable,
      skill,
      skills,
      filteredSkill,
      showDialog,
      submitted,
      existSkillId,
      duplicateSkillId,
      popupDeleteDialog,
      searchString,
      onNewSkill,
      onEditSkill,
      onDeleteSkill,
      onSaveSkill,
      handleDeleteSkill,
      onHideDialog,
    };
  },
};
